import {
    ADD_CONTEXT_PROPERTY,
    REMOVE_CONTEXT_PROPERTY,
    SET_CONTEXT_PROPERTIES,
    UPDATE_CONTEXT_PROPERTY
} from "../actions/contextPropertiesToRetrieveActions";

export default function (state = [], action) {
    switch (action.type) {
        case ADD_CONTEXT_PROPERTY:
            return [...state, action.contextPropertyToRetrieve];
        case REMOVE_CONTEXT_PROPERTY:
            return state.filter((contextPropertyToRetrieve) => contextPropertyToRetrieve !== action.contextPropertyToRetrieve);
        case SET_CONTEXT_PROPERTIES:
            return action.contextPropertiesToRetrieve;
        case UPDATE_CONTEXT_PROPERTY:
            return [...state.map((contextProp) => {
                if (action.name === contextProp.name) {
                    contextProp = {...contextProp, [action.property]: action.value};
                    return contextProp;
                }
                return contextProp;
            })];
        default:
            return state;
    }

}